import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-acd-new-notification-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAcdNewNotificationIconProps extends SvgIconProps  {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfAcdNewNotificationIcon(
  props: CcfAcdNewNotificationIconProps
) {
  return (
    <SvgIcon
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      {...props}
    >
      <circle cx="5" cy="5" r="5" fill="#007CBE" />
    </SvgIcon>
  );
}

export default CcfAcdNewNotificationIcon;
